import * as React from "react";
const SvgArrowDropUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 4 4 4H2z" }));
export default SvgArrowDropUp;
